import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { buildPublicExperienceStyles } from '../../../services/global.service';
import { ButtonModule } from 'primeng/button';
import { ProductDesignTemplatePageModuleDataContent } from '../../../store/app.model';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AppStateSelectors } from '../../../store/app.selectors';
import { SetQRCode, SetTenantId } from '../../../store/app.actions';

@Component({
  selector: 'app-authenticity',
  imports: [
    CommonModule,
    ButtonModule,
  ],
  templateUrl: './authenticity.html',
  styleUrls: ['./authenticity.scss']
})
export class Authenticity implements OnChanges {
  @Input({ required: true }) content!: any;
  @Input({ required: true }) styles!: any;
  @Input({ required: true }) isSelectedModule!: boolean;
  @Input({ required: true }) isFirstModule!: boolean;
  @Input({ required: true }) isLastModule!: boolean;

  items: ProductDesignTemplatePageModuleDataContent[] = [];
  isAuthenticated$: any;
  isTagNotFound$: any;
  qrCode$: any;
  tenantId$: any;

  constructor(private router: Router, private store: Store) {
    this.isAuthenticated$ = this.store.selectSignal(AppStateSelectors.isAuthenticated);
    this.isTagNotFound$ = this.store.selectSignal(AppStateSelectors.isTagNotFound);
    this.qrCode$ = this.store.selectSignal(AppStateSelectors.getQRCode);
    this.tenantId$ = this.store.selectSignal(AppStateSelectors.getTenantId);
    

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.content) {
      if (
        'pageModuleTemplateDataContents' in this.content &&
        Array.isArray(this.content.pageModuleTemplateDataContents)
      ) {
        this.items = this.content.pageModuleTemplateDataContents;
      } else if (
        'contentItems' in this.content &&
        Array.isArray(this.content.contentItems)
      ) {
        this.items = this.content.contentItems;
      } else if (
        'components' in this.content &&
        Array.isArray(this.content.components)
      ) {
        this.items = this.content.components;
      } else {
        this.items = [];
      }
    } else {
      this.items = [];
    }
    

  }

  filter(array: any[] | undefined | null, column: any, value: any) {
    if (!array) return [];
    return array.filter(item => item[column] === value);
  }

  buildStyle(type: string, style: any): string {
    return buildPublicExperienceStyles(type, style);
  }

  onLinkClick(event: Event): void {
    event.preventDefault();
    
    const qrCode = this.getQRCodeFromContent();
    const tenantId = this.getTenantIdFromContent();
    
    // Set QR code and tenant ID in the state
    if (qrCode) {
      this.store.dispatch(new SetQRCode(qrCode));
    }
    if (tenantId) {
      this.store.dispatch(new SetTenantId(tenantId));
    }
    
    // Navigate to scanner
    this.router.navigate(['/scanner']);
  }
  


  private getQRCodeFromContent(): string | null {
    // Try to get QR code from content items
    const qrItem = this.items.find(item => item.type === 'qr' || (item.value as any)?.qrcode);
    if (qrItem?.value && (qrItem.value as any)?.qrcode) {
      return (qrItem.value as any).qrcode;
    }
    
    // Fallback: try to get from URL path
    const path = window.location.pathname;
    const parts = path.split('/').filter(Boolean);
    if (parts.length > 0) {
      return parts[parts.length - 1];
    }
    
    return null;
  }

  private getTenantIdFromContent(): string | null {
    // Try to get tenant ID from URL query params first
    const urlParams = new URLSearchParams(window.location.search);
    const tenantId = urlParams.get('x-tenant-id');
    
    if (tenantId) {
      return tenantId;
    }
    
    // Try to get tenant ID from state
    const stateTenantId = this.tenantId$();
    
    if (stateTenantId) {
      return stateTenantId;
    }
    
    // Fallback to default tenant
    return 'regenesis';
  }
}
